import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiInstagram } from "react-icons/fi";
import { SiTiktok } from "react-icons/si";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const footerColumns = [
  [
    ["About", "/about"],
    ["Shop all", "/shop"],
    ["New in", "/shop?sort=newest"],
    ["Core cuts", "/shop?category=Bottoms"],
  ],
  [
    ["Shipping", "/shipping"],
    ["Return policy", "/returns"],
    ["Terms", "/terms"],
    ["Privacy", "/privacy"],
  ],
  [
    ["Contact", "/contact"],
    ["Product care", "/about"],
    ["Repairs", "/returns"],
    ["Your bag", "/cartpage"],
  ],
];

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const submitNewsletter = (event) => {
    event.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setMessage(valid ? "You're on the list." : "Enter a valid email address.");
    if (valid) setEmail("");
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__grid">
        <section className="site-footer__newsletter">
          <span className="eyebrow">From the workshop</span>
          <h2>Sign up to our newsletter for all the latest information</h2>
          <p>Never miss a product launch, restock or story from the road.</p>
          <form onSubmit={submitNewsletter} noValidate>
            <label className="sr-only" htmlFor="newsletter-email">Email address</label>
            <input
              id="newsletter-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Enter email address"
              aria-describedby="newsletter-message"
            />
            <button type="submit">Sign up</button>
          </form>
          <p id="newsletter-message" className="site-footer__message" aria-live="polite">
            {message}
          </p>
        </section>

        <section className="site-footer__utility">
          <Link className="wordmark wordmark--footer" to="/" onClick={toTop}>
            <span>{siteConfig.wordmark}</span>
            <small>{siteConfig.tagline}</small>
          </Link>
          <div className="site-footer__socials">
            <a href={siteConfig.social.instagram} target="_blank" rel="noreferrer">
              <FiInstagram /> Discover us on Instagram <FiArrowUpRight />
            </a>
            <a href={siteConfig.social.tiktok} target="_blank" rel="noreferrer">
              <SiTiktok /> Follow us on TikTok <FiArrowUpRight />
            </a>
          </div>
          <nav className="site-footer__links" aria-label="Footer navigation">
            {footerColumns.map((column, index) => (
              <div key={index}>
                {column.map(([label, to]) => (
                  <Link key={label} to={to} onClick={toTop}>{label}</Link>
                ))}
              </div>
            ))}
          </nav>
        </section>
      </div>
      <div className="site-footer__copyright">
        <span>© {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.</span>
        <span>United Kingdom · GBP</span>
      </div>
    </footer>
  );
}

export default Footer;
